import { useNodeDeleteAction } from '@/features/drive/functionalities/actions/node/core/node-delete-action'
import { useNodeDownloadAction } from '@/features/drive/functionalities/actions/node/core/node-download-action'
import { useNodeFavoriteAction } from '@/features/drive/functionalities/actions/node/core/node-favorite-action/node-favorite-action'
import { useNodeMoveAction } from '@/features/drive/functionalities/actions/node/core/node-move-action/node-move-action'
import { useNodeRenameAction } from '@/features/drive/functionalities/actions/node/core/node-rename-action/node-rename-action'
import {
    INodeAction,
    NodeAction,
} from '@/features/drive/functionalities/actions/node/core/shared/utils/node-action-helpers'
import { Fragment, ReactNode, useMemo } from 'react'

type IUseNodeFileActionsReturnType = [
    ReactNode,
    Record<Extract<NodeAction, 'MOVE' | 'DOWNLOAD' | 'RENAME' | 'FAVORITE' | 'DELETE'>, INodeAction>,
]

export const useNodeFileActions = (): IUseNodeFileActionsReturnType => {
    const { action: deleteAction, nodes: deleteNodes } = useNodeDeleteAction()
    const { action: downloadAction, nodes: downloadNodes } = useNodeDownloadAction()
    const { action: favoriteAction, nodes: favoriteNodes } = useNodeFavoriteAction()
    const { action: moveAction, nodes: moveNodes } = useNodeMoveAction()
    const { action: renameAction, nodes: renameNodes } = useNodeRenameAction()

    const actions = useMemo(() => {
        return {
            [NodeAction.MOVE]: moveAction,
            [NodeAction.DOWNLOAD]: downloadAction,
            [NodeAction.RENAME]: renameAction,
            [NodeAction.FAVORITE]: favoriteAction,
            [NodeAction.DELETE]: deleteAction,
        }
    }, [deleteAction, downloadAction, favoriteAction, moveAction, renameAction])

    return useMemo(
        () => [
            <Fragment key="node-file-actions">
                {downloadNodes}
                {renameNodes}
                {favoriteNodes}
                {moveNodes}
                {deleteNodes}
            </Fragment>,

            actions,
        ],
        [actions, deleteNodes, downloadNodes, favoriteNodes, moveNodes, renameNodes]
    )
}
